export class AuthorizationError {
  private static AllAuthorizationErrors: any = {};

  private constructor(public errorCode: string, public errorText: string) {
    AuthorizationError.AllAuthorizationErrors[errorCode] = this;
  }

  static notDevOpsUser = new AuthorizationError(
    'err.not-devops-user',
    'In order to use this site, you must log in using the "ERM DevOps" Connect account.');

  static parse(errorCode: string): AuthorizationError {
    return AuthorizationError.AllAuthorizationErrors[errorCode];
  }
}
